var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "4 0 12 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: "var(--icon-stroke-width, 1.5)",
    d: "M14.993 7.279V5.994a4.995 4.995 0 0 0-9.988 0v1.285M10 7.003v5.993m-4.993-.274v1.284a4.993 4.993 0 1 0 9.987 0v-1.284"
  })));
};
export default SvgLink;